// extracted by mini-css-extract-plugin
module.exports = {"sidebar-layout":"yS6AO6hM","menu":"d7LYPnvs","menu-item-li":"kEo8gp_E","menu-item":"Dqohd4gE","active":"iasCfv1r","main":"oSio_0tV"};